import { TableGeneratePurchaseOrder } from './components'

export const TabGeneratePurchaseOrder = () => {
  return <TableGeneratePurchaseOrder />
}
